"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var storage_1 = __importDefault(require("./storage"));
var createRoutes = function (routes) {
    var permissions = storage_1.default.getPermissions();
    return routes
        .filter(function (route) { return hasPermission(permissions, route.permissions); })
        .map(function (route) { return react_1.default.createElement(react_router_dom_1.Route, { key: route.path, path: route.path, component: route.component }); });
};
var hasPermission = function (necessaryPermissions, permissions) {
    return !necessaryPermissions || !permissions || necessaryPermissions.some(function (p1) { return permissions.some(function (p2) { return p2 === p1; }); });
};
exports.default = createRoutes;
